import React from 'react';
import FormattedLabel from '../../cmp/intl/FormattedLabel';

export default function FormInput({id, children, required}) {
    return (<div className={'form-group'}>
        <FormattedLabel id={id} required={required}/>
        {children}
    </div>);
}
